<template>
  <div :class="avatarGroupClass">
    <component
      :is="element.type.name"
      v-for="(element, index) of visibleAvatars"
      :key="element.name"
      v-bind="getAvatarAttrs(element, index)"
    />
    <div
      v-if="totalHiddenAvatars"
      class="sb-avatar-group__more"
      data-testid="sb-more-avatars-label"
    >
      {{ moreAvatarsLabel }}
    </div>
  </div>
</template>

<script lang="ts">
import { isSizeValid } from '../Avatar/utils'

import SbAvatar from '../Avatar/SbAvatar.vue'

export default {
  name: 'SbAvatarGroup',

  components: {
    SbAvatar,
  },

  props: {
    darkBg: Boolean,
    maxElements: {
      type: Number,
      default: 5,
    },
    size: {
      type: String,
      default: null,
      validator: isSizeValid,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    avatars() {
      const children = this.$slots.default && this.$slots.default()
      const useGrandchildren =
        children &&
        children.length === 1 &&
        children[0].children &&
        children[0].children[0]?.type.name === 'SbAvatar'
      const avatarChildren = useGrandchildren ? children[0].children : children
      return avatarChildren.filter(({ type }) => type.name === 'SbAvatar')
    },

    totalAvatars() {
      return this.avatars.length
    },

    visibleAvatars() {
      return this.avatars.slice(0, this.maxElements)
    },

    hiddenAvatars() {
      const hiddenAvatarsIndex = this.maxElements - this.totalAvatars

      return hiddenAvatarsIndex < 0
        ? this.avatars.slice(hiddenAvatarsIndex)
        : []
    },

    totalHiddenAvatars() {
      return this.hiddenAvatars.length
    },

    avatarGroupClass() {
      const sizeClass = this.size && `sb-avatar-group--${this.size}`
      const darkBgClass = this.darkBg && `sb-avatar-group--dark-bg`

      return ['sb-avatar-group', sizeClass, darkBgClass]
    },

    moreAvatarsLabel() {
      const { totalHiddenAvatars } = this
      return `+${totalHiddenAvatars}`
    },
  },

  methods: {
    getAvatarAttrs(element, index) {
      return {
        ...element.props,
        useTooltip: true,
        size: this.size,
      }
    },
  },
}
</script>
